
export const ROLE_OPTIONS = [
    {
        label: "Admin",
        value: "admin"
    },
    {
        label: "Sub-Admin",
        value: "subadmin"
    },
    {
        label: "Affiliate Manager",
        value: "affiliate_manager"
    }
];

